/* eslint-disable */
import { groupBy, isEmpty, omit, pick } from 'lodash-es';

import { formatDate, getCleanedUrlParams, sortArray } from '@utils';
import { URLS } from 'layouts/DrawerLayout/constants';
import theme from 'config/theme';

import { FILTER_OPERATOR_ENUMS, FILTER_RULE_ENUMS } from '@constants';
import { BILLING_PAGE_SIZE, BILLING_TABS } from './constants';
import { BILLING_TABLE_FIELDS_TO_SEARCH } from 'constants/fieldsToSearch';

export const getColumns = (tasks = [], board = '') => {
  const order = BILLING_TABS[board].statusOrder;
  const groupedByStatus = groupBy(tasks, 'status');

  const columns = order.reduce((acc, cur) => {
    acc.push({
      id: cur,
      title: BILLING_TABS[board]?.statuses?.[cur]?.label || cur,
      cards: groupedByStatus[cur] || [],
      styles: {
        backgroundColor: theme.palette.blues.babyBlue200,
        color: theme.palette.blues.babyBlue900,
      },
      value: true,
      label: BILLING_TABS[board]?.statuses?.[cur]?.label || cur,
      key: cur,
    });

    return acc;
  }, []);

  return columns;
};

export const normaliseBillingTasks = (data = [], assignees = []) => {
  if (!data.length > 0) {
    return {};
  }
  const assigneesMap = assignees.reduce((acc, cur) => {
    acc[cur.value] = cur;
    return acc;
  }, {});

  const tasks = data.map((item) => {
    const assignee = assigneesMap[item.assignee] || {};
    return {
      ...item,
      href: `${URLS.billing}/${item?.id}`,
      plate: item.customFields?.vehiclePlate || '',
      date: item.createdAt ? formatDate(item.createdAt, 'dd/MM/yyyy') : null,
      status: item?.status,
      assignee,
      description: item?.customFields?.vehicleDescription || '-',
      createdAt: item?.createdAt
        ? formatDate(item?.createdAt, 'dd/MM/yyyy')
        : '-',
      id: item?.id,
      title: item.customFields?.title || '',
    };
  });

  return tasks;
};

export const getBillingQueryParams = (payload = {}) => {
  if (!payload?.pageSize) {
    payload.pageSize = BILLING_PAGE_SIZE;
  }
  if (!payload?.page) {
    payload.page = '1';
  }

  if (!payload.order) {
    payload.order = 'desc';
    payload.orderBy = 'createdAt';
  }

  return getCleanedUrlParams(
    pick(payload, [
      'page',
      'pageSize',
      'order',
      'orderBy',
      'assignee',
      'query',
      'archived',
    ])
  );
};

export const getBillingRequestPayload = (payload = {}) => {
  const fields =
    omit(payload, [
      'page',
      'pageSize',
      'order',
      'orderBy',
      'boardType',
      'query',
      'board',
      'archived',
    ]) || {};
  const { archived } = payload;

  const value = [
    {
      field: 'archived_at',
      operator: 0,
      type: archived ? FILTER_RULE_ENUMS.noEmpty : FILTER_RULE_ENUMS.isEmpty,
    },
    ...Object.keys(fields).map((field) => ({
      field,
      operator: FILTER_OPERATOR_ENUMS['='],
      type: FILTER_RULE_ENUMS.ComparableRuleType,
      value: payload[field],
    })),
  ];

  return {
    boardType: payload.boardType,
    type: FILTER_RULE_ENUMS.AndRuleType,
    field: null,
    operator: null,
    value,
  };
};

const getValue = (data, current) => {
  return (
    data.find((item) => item?.value === current) || {
      value: '',
      text: '',
    }
  );
};

const getBoard = (data, current) => {
  return (
    data.find((item) => item?.id === current) || {
      value: '',
      text: '',
    }
  );
};
export const handleBillingTaskData = ({
  data = {},
  assignees = [],
  stages = [],
  boards = [],
}) => {
  if (!data || isEmpty(data)) {
    return {};
  }
  const boardId = data.id?.split('-')?.[0];
  const assignee = getValue(assignees, data.assignee);
  const status = getValue(stages, data.status);
  const board = getBoard(boards, boardId);

  const task = {
    ...data,
    assignee,
    status,
    board,
    changelog: data?.changelog?.reverse(),
    customFields: {
      ...omit(data.customFields, ['comments']),
    },
    subscriptionOwner: data.customFields.userFirstName
      ? `${data.customFields.userFirstName} ${data.customFields.userLastName}`
      : '',
    comments: sortArray(data?.comments, 'createdAt', 'desc')?.map((entry) => {
      return {
        id: entry?.id,
        date: entry?.createdAt
          ? formatDate(entry?.createdAt, 'dd MMMM yyyy')
          : '-',
        time: entry?.createdAt ? formatDate(entry?.createdAt, 'HH:mm') : '-',
        name: entry?.user || '-',
        comment: entry?.comment,
        edit: entry?.editedAt
          ? formatDate(entry?.editedAt, 'dd MMMM yyyy HH:mm')
          : '',
      };
    }),
  };
  return task;
};

export const normalizeVehicleData = (data = {}) => {
  const properties = [];

  if (data.properties?.fuelType) {
    properties.push(data.properties.fuelType);
  }
  if (data.properties?.transmission) {
    properties.push(data.properties.transmission);
  }
  if (data.properties?.color) {
    properties.push(data.properties.color);
  }
  if (data.year) {
    properties.push(data.year);
  }
  return {
    internalId: data.internalId,
    id: data.id,
    title: `${data.manufacturer ? `${data.manufacturer}, ` : ''}${
      data.model || ''
    }`,
    plate: data.plate,
    vin: data.vin,
    image: data?.images?.[0]?.url,
    properties,
    procurement: data.procurement,
  };
};

export const getPayload = (values) => {
  Object.keys(values)?.forEach((key) => {
    if (values[key] === '') {
      values[key] = null;
    }
  });

  const cleanedValues = omit(values, [
    'assignee',
    'documents',
    'tags',
    'status',
    'updatedAt',
    'updatedBy',
    'changelog',
    'images',
    'parent',
    'name',
    'createdAt',
    'comments',
    'createdBy',
  ]);

  return {
    // assignee: values.assignee?.value,
    customFields: {
      ...cleanedValues.customFields,
    },
  };
};
